<template>
	<div>
		<div
			class="modal fade"
			id="importTagsData"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px;top:80px"
				>
					<div class="modal-header" style = "flex: 0 0 auto">
						<h5 class="modal-title" id="exampleModalLongTitle">Upload Tags</h5>
						<button type="button" class="close" data-dismiss="modal" @click = "getList">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class = "form-group row" style="margin-top:25px;margin-left:40px;">
							<div v-if = "isFileUploading" class="spinner-border" ></div>
							<div v-else class = "col-md-12 row">
								<div class = "col-md-12 row">
									<div class = "col-md-3" v-if = "!isDataSyncing && !isDataUploaded">
										<input
											class="choose"
											type="file"
											placeholder="Import Data From csv"
											multiple="false"
											accept=".csv"
											@change="uploadFile"
										>
									</div>
									<div class = "col-md-1"></div>
									<div  v-if = "isDataSyncing" class = "col-md-5" style = "padding:0px;margin:0px" >
										<p style = "color:red">.....Uploading Data please wait</p>
									</div>
									<div class = "col-md-12 pt-5" v-if="!isDataSyncing && isDataUploaded && hasUploadError">
										<p style = "color:red">File Upload Failed!</p>
										<p style = "color:red">Invalid Columns: {{uploadError.invalidColumns}}</p>
										<p style = "color:red">Missing Columns: {{uploadError.missingColumns}}</p>
										<p style = "color:red">Invalid Column Count: {{uploadError.invalidColumnCount}}</p>

									</div>
									<div class = "col-md-10 pt-5" v-else-if="isDataUploaded && !isDataSyncing">
										<p style = "color:rgb(39, 196, 117)">{{isDataUploaded}}</p>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="modal-footer" style = "flex: 0 0 auto">
						<div class="mt-2" style="text-align: center">
							<button type="button" class="btn btn-primary" data-dismiss="modal" @click = "getList">Done</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import XLSX from "xlsx";

export default {
	name: "ImportTags",
	mounted() {
		//this.openCampaignGroup();
	},
	data() {
		return {
			isFileUploading:false,
			fileUploadedName:"",
			isDataSyncing:false,
			isDataUploaded: '',
			hasUploadError: false,
			uploadError: {},
			notaddedAsin: []
		};
	},
	watch: {},
	methods: {
		getList(){
			this.fileUploadedName = "";
			this.isDataSyncing = false;
			this.isFileUploading = false;
			this.isDataUploaded = '';
			this.hasUploadError = false,
			this.$emit("closePopUp")
		},

		uploadFile(evt){
			let file = evt.target.file || evt.target.files[0];
			let vm = this;

			this.isFileUploading = true;
			this.$store.dispatch("product/getPresighnedURL").then((res) => {
				let data = {
					url : res.uploadUrl,
					data: file
				}
				vm.$store.dispatch("product/uploadFile", data).then(response => {
					vm.isFileUploading = false
					vm.fileUploadedName = file.name
					
					let payload = {
						uploadUrl: res.uploadUrl,
						downloadUrl: res.downloadUrl,
						name: file.name,
						userName: JSON.parse(window.localStorage.session).name,
						isSeller: this.$store.state.isSeller
					}
					vm.isDataSyncing = true;
						vm.$store.dispatch("product/updateFileData", payload).then((res) => {
							console.log('UPLOAD_RETURNED',res)
							vm.isDataSyncing = false;
							//updateFileData data will be false unless 
							if(res.data && res.status !== 200){
								vm.hasUploadError = true
								vm.uploadError = res.data
								vm.isDataUploaded = 'File import failed:';
							} else {
								vm.isDataUploaded = 'File has been imported successfully. A report will be sent to your email at the completion of the tagging process.';
							}
						})
				})
			})

		},
	}
}
</script>
<style lang="scss">
</style>
